module.exports = __webpack_public_path__ + "c5c36a1173e012c1ffd9f08806dcb6a4.MP3";